import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeadsService {
  leadData = new Subject<any>();
  currentData = this.leadData.asObservable();

  changeData(data: any) {
    this.leadData.next(data);
  }
  constructor(private ws: PostmethodService) { }

  getLeads(queryParams: any) {
    return this.ws.wsGet(environment.baseUrl + "/lead/leads?stage=1&" + queryParams);
  }

}